import * as Scrivito from "scrivito";
import ImageOrVideo from "^/Components/ImageOrVideo";
import formatDate from "^/utils/formatDate";
import I18n from "^/config/i18n";

function NewsItem({ page }) {
  const date = page.get("publishFromDate");
  return (
    <Scrivito.InPlaceEditingOff>
      <div className="row shadow mx-0 mb-3 rounded overflow-hidden">
        <div className="col-sm-4 px-0">
          <ImageOrVideo widget={page} teaser={true} />
        </div>
        <div className="col-sm-8 py-2">
          <Scrivito.ContentTag
            content={page}
            attribute="title"
            tag="h3"
            className="m-0 p-0"
          />
          <div className="my-2">
            <span className="text-gray">{formatDate(date, "DD.MM.YYYY")}</span>
          </div>
          <Scrivito.ContentTag content={page} attribute="description" />
          <Scrivito.LinkTag
            className="btn btn-link ps-0 py-1 text-light-blue"
            to={page}
          >
            <i className="las la-angle-right" /> {I18n.t("General see more")}
          </Scrivito.LinkTag>
        </div>
      </div>
    </Scrivito.InPlaceEditingOff>
  );
}

export default Scrivito.connect(NewsItem);
